<script>
export default {
    name: 'BaseCalendarNavigationPeriodPopover',
};
</script>

<script setup>
import { computed, ref } from 'vue';
import { VIEW } from '@/components/base-components/components/calendar/index.js';
import BaseCalendarNavigationPeriod
    from '@/components/base-components/components/calendar/components/navigation/period/index.vue';

const props = defineProps({
    value:            {
        type: Date,
    },
    label:            {
        type: String,
    },
    view:             {
        type:      String,
        default:   VIEW.MONTH,
        validator: value => Object.values(VIEW).includes(value),
    },
    firstDayOfWeek:   {
        type:    Number,
        default: 1,
    },
    formatterOptions: {
        type: Object,
    },
    disabled:         {
        type: Boolean,
    },
});

const emit = defineEmits({
    input: null,
});

const model = computed({
    get: () => props.value ?? new Date(),
    set: value => emit('input', value),
});

const showPeriod = ref(false);

function toggle() {
    showPeriod.value = !showPeriod.value;
}
</script>

<template>
    <base-popover
        v-model="showPeriod"
        trigger="manual"
        :disabled="disabled"
    >
        <template #reference>
            <slot name="reference" :label="label" :toggle="toggle">
                <base-button
                    size="large"
                    custom-size-class="px-2 py-1.5"
                    custom-text-class="text-base"
                    :label="label"
                    :text-transform="false"
                    :disabled="disabled"
                    text
                    @click="toggle"
                />
            </slot>
        </template>

        <base-calendar-navigation-period
            v-model="model"
            class="p-2"
            :view="view"
            :first-day-of-week="firstDayOfWeek"
            :formatter-options="formatterOptions"
            @input="showPeriod = false"
        />
    </base-popover>
</template>
